import { AlertCircle, CheckCircle2, Clock, Loader2, XCircle } from 'lucide-react';

// Derives a display status for a product from its verification chain,
// distinguishing "nothing scanned yet" from "some steps done, not all" —
// the backend only stores a binary verificationStatus (pending/verified/
// rejected) until every chain step is verified, so both states otherwise
// render as the same "Pending" badge.
export const getVerificationDisplayStatus = (product) => {
  if (product?.verificationStatus === 'rejected') return 'rejected';
  if (product?.verificationStatus === 'verified') return 'verified';

  const chain = product?.verificationChain || [];
  const hasProgress = chain.some((step) => step.status === 'verified');
  return hasProgress ? 'in_progress' : 'pending';
};

export const VERIFICATION_STATUS_LABEL = {
  verified: 'Verified',
  in_progress: 'In Progress',
  pending: 'Pending',
  rejected: 'Rejected',
};

export const VERIFICATION_STATUS_TONE = {
  verified: 'success',
  in_progress: 'info',
  pending: 'warning',
  rejected: 'danger',
};

export const VERIFICATION_STATUS_ICON = {
  verified: CheckCircle2,
  in_progress: Loader2,
  pending: Clock,
  rejected: XCircle,
  default: AlertCircle,
};
